<template>
    <div>
        <div v-if="!actionCompleted" class="processing">
            <h4>Processing bulk action...</h4>
            <p>Please wait while we update your records.</p>
            <div class="loader-container">
                <md-progress-spinner md-mode="indeterminate" :md-diameter="30"></md-progress-spinner>
            </div>
        </div>
        <div v-else class="complete">
            <md-icon class="success-icon">check_circle</md-icon>
            <h4>Bulk action completed successfully!</h4>
            <p>It may take a few moments for the changes to appear in the Jobs grid.</p>
            <md-button class="md-primary md-raised" @click="acknowledgeComplete">Close</md-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BulkActionProgress',
    props: {
        actionCompleted: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        acknowledgeComplete() {
            this.$emit('acknowledge');
        }
    }
};
</script>

<style lang="scss" scoped>
.processing,
.complete {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px;
    text-align: center;

    .loader-container {
        margin-top: 30px;
    }

    .success-icon {
        font-size: 60px;
        color: #4caf50;
        margin-bottom: 20px;
    }
}
</style>
